import React from 'react';
import {
    Dialog,
    DialogContent,
    Button,
    DialogActions,
    DialogContentText,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const ModalConfirm = ({ open, handleSend, handleClose }) => {
    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogContent>
                <DialogContentText>{t('Documents.SendInfo')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {t('Buttons.Cancel')}
                </Button>
                <Button onClick={handleSend} color="primary">
                    {t('Buttons.Submit')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
